const content = {
  logoHome: "Home",
  performance: "Performance",
  performanceAndIncentives: "Performance & Incentives",
  earlyIncentives: "Early Incentives",
  myGroup: "My Group",
  leaderGrowth: "Leader Growth",
  resources: "Resources",
  frequentlyUsed: "Frequently Used",
  toggleMenu: "Toggle Menu",
  academy: "Academy",
  events: "Events",
  amwayIntelligence: "Amway Intelligence",
  linkTitle: {
    academyV2: "Academy",
    monthlyPerformance: "Monthly Performance",
    annualPerformance: "Annual Performance",
    performanceBonus: "Performance Bonus Detail",
    earningsCalculator: "Earnings Calculator",
    csi: "Customer Sales Incentive{symbol}",
    bronzeFoundation: "Bronze Foundation{symbol}",
    bronzeBuilder: "Bronze Builder{symbol}",
    cml: "Customer/Member List",
    customerMemberList: "Customer Member List",
    los: "Line of Sponsorship (LOS)",
    losShort: "Line of Sponsorship",
    edlos: "Emerald & Diamond LOS",
    actionReports: "Action Reports",
    watchlist: "Watchlist",
    performancePlus: "Performance Plus{symbol}",
    performanceElite: "Performance Elite{symbol}",
    performancePlusElite: "Performance Plus and Elite{symbol}",
    personalGrowthMonthly: "Monthly Personal Group Growth{symbol}",
    personalGrowthAnnual: "Annual Personal Group Growth{symbol}",
    personalGroupGrowth: "Personal Group Growth{symbol}",
    personalGroupTieredIncentive: "Personal Group Tiered Incentive{symbol}",
    frontlineGrowth: "Frontline Growth Incentive{symbol}",
    leadershipPlus: "Leadership Plus{symbol}",
    twoTimeCashIncentive: "Two Time Cash Incentive{symbol}",
    otci: "One Time Cash Incentive{symbol}",
    cci: "Comeback Cash Incentive{symbol}",
    a70Ttca: "A70 Two Time Cash Award{symbol}",
    feedback: "Provide Us Feedback",
    learnAboutCpp: "Learn About Core Plus{symbol}",
    learnAboutCorePlan: "Learn About Core Plan",
    logOut: "Log Out",
    hat: "HAT/GAR",
    faa: "FAA",
    leadershipSeminar: "Leadership Seminar",
    leadershipSeminarEsan: "Leadership Training Seminar",
    personalGroupGrowthGCR: "Personal Group Growth Incentive{symbol}",
    newAboActivation: "Path to Bronze{symbol}",
    pathToBronze: "Path to Bronze{symbol}",
    bronzeGroupTracking: "Bronze Group Tracking",
    mbi: "My Business Income",
    academy: "Academy",
    perfIncomeDashboardLink: "Dashboard",
    groupManagementDashboardLink: "Dashboard",
    groupManagementActionCenterLink: "Action Center",
    performanceDashboard: "Performance Dashboard",
    groupManagementDashboard: "Group Management Dashboard",
    groupManagement: "Group Management",
    strongStartIncentive: "Strong Start Incentive{symbol}",
    bronzeIncentives: "Bronze Incentives",
    qcg: "QC Growth Incentive{symbol}",
    visionBonus: "Vision Bonus{symbol}",
    monthlyQ: "Monthly Q1/QV{symbol}",
    qGrowthIncentive: "Q Growth Incentive{symbol}",
    healthWellbeing: "Health and Wellbeing Bonus{symbol}",
    annualq: "Annual Q+",
    frontlineQ: "Frontline Q+",
    ssiUplineReport: "Strong Start Incentive{symbol} Upline Report",
    diamondBonus: "A70 100+ Diamond Bonus+",
    pathToA70: "Path to A70+",
    a70EliteBonus: "A70 Elite Bonus+",
    whosNew: "Who's New",
    whosNewWithCustomers: "New ABO/PC Activity",
    whosClose: "Who's Close",
    birthdays: "Birthdays",
    renewals: "Renewals",
    nonBonusableBv: "Non-Bonusable BV",
    cvrCompliance: "CVR Compliance",
    iboOnboarding: "IBO Onboarding",
    cbrClockCheck: "CBR Clock",
    onlineStatements: "Online Statements",
    retroPvInquiry: "Return/Retro PV Inquiry Report",
    saqCertification: "Sponsoring Activity Qualification Report",
    foundersSalesIncentive: "Founders Sales Incentive{symbol}",
    foundersSalesIncentiveReport: "Founders Sales Incentive{symbol} Report",
    ttca: "Two Time Cash Award",
    emeraldBonus: "Emerald Bonus{symbol}",
    diamondPlusBonus: "Diamond Plus Bonus{symbol}",
    foundersPlatinum: "Founders Platinum Status",
    saqActionReport: "Sponsoring Activity Qualification Report",
    groupSopTracking: "SOP Report",
  },
  performanceAndIncome: "Performance & Income",
  groupManagement: "Group Management",
  myBiz: "MyBiz",
};
export default content;
